import { Button, CreateAlert, InputWraper, useForm } from 'modules';
import React, { FC } from 'react';
import * as Yup from 'yup';

import { InputText } from '../../components';
import { translate } from '../../languages';
import { AdminService } from '../../services/admin';

export const MoveBranch: FC<{ data: any; onFinishEdit: () => void }> = (
  props,
) => {
  const { handleSubmit, getInputProps, isSubmitting } = useForm({
    structure: [
      {
        name: 'emailTo',
        validate: Yup.string().required(translate('must-be-provided')),
      },
    ],

    onSubmit: async (values) => {
      const { Email } = props.data;
      const { emailTo } = values;
      return AdminService.moveBranch({
        emailTransfer: Email,
        emailTo,
      })
        .then(() => {
          CreateAlert({
            message: 'Move branch success.',
            type: 'success',
          });
          props.onFinishEdit();
        })
        .catch((error) => {
          CreateAlert({
            message: translate(error.message),
            type: 'danger',
          });
        });
    },
  });
  return (
    <>
      <p
        style={{
          color: 'white',
          fontSize: '20px',
          fontWeight: 'bold',
          marginBottom: '20px',
        }}
      >
        This action can affect the branch's metrics. Are you sure you understand
        and confirm still doing?
      </p>
      <form className='Edit' onSubmit={handleSubmit}>
        <InputWraper
          label={translate('email-address')}
          inputProps={getInputProps('emailTo')}
          component={InputText}
        />

        <div>
          <Button
            label='Move'
            isMiddle
            buttonType='success'
            className='btnBan'
            type='submit'
          />
        </div>
      </form>
    </>
  );
};
